import React from 'react';
import { Link } from 'react-router-dom';
import { blogs } from '../data/mockData';
import { ArrowRight } from 'lucide-react';

const BlogCard = ({ blog }) => {
  return (
    <div className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100">
      <div className="relative overflow-hidden">
        <img
          src={blog.image}
          alt={blog.title}
          className="w-full h-52 object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-[#166534] text-white text-xs font-medium px-3 py-1 rounded-full">
            {blog.category}
          </span>
        </div>
      </div>
      <div className="p-6">
        <p className="text-gray-400 text-sm mb-2">{blog.date}</p>
        <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#166534] transition-colors line-clamp-2">
          {blog.title}
        </h3>
        <p className="text-gray-600 text-sm mb-4 line-clamp-2">{blog.excerpt}</p>
        <Link
          to={`/blogs/${blog.id}`}
          className="inline-flex items-center gap-2 text-[#166534] font-medium text-sm hover:gap-3 transition-all"
        >
          Read More
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};

const BlogSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Label */}
        <div className="text-center mb-4">
          <span className="text-[#166534] font-medium text-sm uppercase tracking-wider">Our Blog</span>
        </div>

        {/* Section Title */}
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 text-center mb-12 max-w-3xl mx-auto">
          Healthcare News Tips &<br />Wellness Advice
        </h2>

        {/* Blog Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog) => (
            <BlogCard key={blog.id} blog={blog} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
